import React, { useState, useEffect } from "react";
import PriceInput from "./PriceInput";
import "./TipInput.scss";

interface TipInputProps {
  subtotal: number;
  tip: number;
  setTip: React.Dispatch<React.SetStateAction<number>>;
  editable: boolean;
}

const PERCENTS = [0.12, 0.18];

const TipInput: React.FC<TipInputProps> = ({
  subtotal,
  tip,
  setTip,
  editable,
}) => {
  const [selectedPercent, setSelectedPercent] = useState<number | null>(null);
  const [customPercent, setCustomPercent] = useState("");

  // when tip changes, select corresponding percentage button
  useEffect(() => {
    if (subtotal === 0) return;

    const match = PERCENTS.find(
      (p) => (p * subtotal).toFixed(2) === tip.toFixed(2),
    );
    setSelectedPercent(match ?? null);

    // update custom input to show current percentage when no preset matches
    if (!match && subtotal > 0) {
      setCustomPercent(Math.round((tip / subtotal) * 100).toString());
    }
  }, [subtotal, tip]);

  // when clicked percent button, setTip correspondingly
  const handlePercentageClick = (percent: number) => {
    setTip(subtotal * percent);
    setSelectedPercent(percent);
  };

  return (
    <div className="tip-input">
      <PriceInput
        price={tip}
        setPrice={setTip}
        editable={editable}
        style={{ width: "100%", boxSizing: "border-box" }}
      />
      {/* the percent shortcuts only make sense while the tip is editable */}
      {editable && (
        <div className="tip-buttons">
          {PERCENTS.map((percent) => (
            <button
              key={percent}
              className={`tip-button ${
                selectedPercent === percent ? "selected" : ""
              }`}
              onClick={() => handlePercentageClick(percent)}
            >
              {Math.round(percent * 100)}%
            </button>
          ))}
          <div
            className={`tip-button custom ${
              selectedPercent === null && tip > 0 ? "selected" : ""
            }`}
          >
            <input
              type="text"
              value={customPercent}
              onChange={(e) =>
                setCustomPercent(e.target.value.replace(/\D/g, ""))
              }
              onBlur={() => {
                const num = parseInt(customPercent);
                if (!isNaN(num) && num >= 0) {
                  setTip((subtotal * num) / 100);
                }
              }}
              onFocus={(e) => {
                const target = e.target;
                setTimeout(() => target.select(), 0);
              }}
              placeholder="__"
            />
            <span>%</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TipInput;
